var map = {
	"./abbott_gmbh.png": 693,
	"./abbvie_deutschland_gmbh__co_kg.png": 7258,
	"./abbvie_deutschland_gmbh__co_kg_amgen_gmbh_und_incyte_biosciences_germany_gmbh.png": 773,
	"./amgen_gmbh.png": 8069,
	"./astellas_pharma_gmbh.png": 278,
	"./astrazeneca_gmbh.png": 5310,
	"./bial_deutschland_gmbh.png": 8929,
	"./biogen_gmbh.png": 3878,
	"./biomarin_deutschland_gmbh.png": 8817,
	"./bristol-myers_squibb_gmbh__co_kgaa.png": 8327,
	"./bristol-myers_squibb_gmbh__co_kgaa_und_abbvie_deutschland_gmbh__co_kg.png": 9025,
	"./bristol-myers_squibb_immunocation_gmbh__co_kgaa.png": 5546,
	"./camurus_gmbh.png": 5808,
	"./camurus_gmbh_big.png": 4477,
	"./esanum_gmbh.png": 2889,
	"./ever_pharma_gmbh.png": 23,
	"./gilead_sciences_gmbh.png": 2401,
	"./gruenenthal_gmbh.png": 4832,
	"./hexal_ag.png": 8633,
	"./incyte_biosciences_germany_gmbh.png": 328,
	"./ipsen_pharma_gmbh.png": 667,
	"./janssen-cilag_gmbh.png": 7489,
	"./msd_sharp__dohme_gmbh.png": 3201,
	"./novartis.png": 1220,
	"./organon-logo.png": 9261,
	"./roche_pharma_ag.png": 4749,
	"./springworks_logo.png": 8267,
	"./teva_gmbh.png": 3820,
	"./ultragenyx-logo.png": 7694,
	"./vertex_pharmaceuticals-logo.png": 6441,
	"./winicker_norimed_gmbh.png": 360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6235;